<template>
  <div v-if="visible" class="frequency">
    <ncs-empty-result v-if="result.elements === 0"/>
    <div v-else class="container">
      <div class="alert alert-primary">
        {{ t('result.frequency.there_are') }}
        <a href="#" @click.prevent="showKwic" v-html="fn(result.elements)"></a>
        {{ t('result.frequency.coincidences') }}
        {{ t('result.frequency.in_the') }}
        <span v-html="fn(result.elements_reference)"></span>
        {{ t('result.frequency.reference_corpus') }}
        <span v-html="t('result.frequency.per_million', { per_million: fn(perMillion) })"></span>
        <br>
        <span v-html="t('result.frequency.in_documents', {
          documents: fn(result.documents),
          documents_reference: fn(result.documents_reference)
        })"></span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { round } from 'lodash-es'
import { computed, defineComponent, nextTick } from 'vue'
import { useResultTypeStore, useApiStore, useNcsI18n, FrequencyResult } from 'ncs'

export default defineComponent({
  setup() {
    const { t, fn } = useNcsI18n()
    const resultTypeStore = useResultTypeStore()
    const apiStore = useApiStore()

    const result = computed(() => apiStore.response as FrequencyResult)
    const perMillion = computed(() => round(result.value.elements * 1000000 / result.value.elements_reference, 2))
    const visible = computed(() => apiStore.query?.type === 'frequency')

    const showKwic = async () => {
      resultTypeStore.type = 'kwic'
      await nextTick()
      return apiStore.executeQuery()
    }

    return {
      t,
      fn,
      visible,
      result,
      perMillion,
      showKwic
    }
  }
})
</script>
